import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { api, apiError } from "@/lib/api";

export default function AdminLogin() {
  const navigate = useNavigate();
  const [form, setForm] = useState({ email: "", password: "" });
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      const { data } = await api.post("/auth/login", { email: form.email.trim(), password: form.password });
      localStorage.setItem("sumiran_token", data.token);
      navigate(data.user?.role === "gate" ? "/gate" : "/admin/dashboard");
    } catch (err) {
      setError(apiError(err, "Login failed"));
    }
    setLoading(false);
  };

  return (
    <div className="min-h-screen bg-ink text-bone flex items-center justify-center px-6" data-testid="admin-login-page">
      <div className="noise-overlay" aria-hidden="true" />
      <div className="w-full max-w-md border border-bone/15 bg-surface p-10">
        <div className="flex items-baseline gap-2">
          <span className="font-hindi text-3xl text-saffron">सुमिरन</span>
          <span className="font-display text-xs tracking-[0.25em] text-bone">ADMIN</span>
        </div>
        <h1 className="mt-6 font-serif text-3xl text-bone">Band Login</h1>
        <p className="mt-2 text-sm text-ash">Manage the event, videos, gallery and enquiries.</p>
        <form onSubmit={submit} className="mt-8 space-y-4" data-testid="admin-login-form">
          <input type="email" required placeholder="Email" value={form.email}
            onChange={(e) => setForm({ ...form, email: e.target.value })}
            className="w-full bg-ink border border-bone/15 px-4 py-3.5 text-bone placeholder:text-ash/60 focus:border-saffron focus:outline-none transition-colors"
            data-testid="admin-email-input" />
          <input type="password" required placeholder="Password" value={form.password}
            onChange={(e) => setForm({ ...form, password: e.target.value })}
            className="w-full bg-ink border border-bone/15 px-4 py-3.5 text-bone placeholder:text-ash/60 focus:border-saffron focus:outline-none transition-colors"
            data-testid="admin-password-input" />
          {error && <p className="text-sm text-red-400" data-testid="admin-login-error">{error}</p>}
          <button type="submit" disabled={loading}
            className="w-full py-4 bg-saffron text-ink font-medium tracking-wide hover:bg-gold transition-colors disabled:opacity-50 flex items-center justify-center gap-2"
            data-testid="admin-login-submit">
            {loading && <Loader2 size={18} className="animate-spin" />}
            {loading ? "Signing in…" : "Sign In"}
          </button>
        </form>
      </div>
    </div>
  );
}
